module.exports = __webpack_public_path__ + "static/media/17UN-Women2.faf29f83.jpg";